import React from "react";
import classes from "./MySelect.module.css"

const MySelect = function({options, defaultValue, value, onChange, ...props}){
    return(
            <select
                className={classes.mySelect}
                value={value}
                onChange={event => onChange(event.target.value)}
                {...props}
            >
                <option disabled value="0">{defaultValue}</option>
                {options.map(option =>
                    <option key={option.value} value={option.value}>
                        {option.name}
                    </option>
                )}
            </select>
    )
}

export default MySelect;